import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get_UploadAdapter1jp2f4wtvjtde as get_UploadAdapter,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_BooleanAdapterefxw889yjdy4 as get_BooleanAdapter,
  get_IntAdapter2kzerdn7hhunh as get_IntAdapter,
  get_DoubleAdapter3vjvxl0ttbawu as get_DoubleAdapter,
  get_LongAdapter1acs38m0a7icu as get_LongAdapter,
  get_FloatAdapter8hkphxq3v57l as get_FloatAdapter,
  get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter,
} from './Adapters.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from './ExecutionContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {
      constructor() {
        Key_instance = this;
        this.g45_1 = (new (Builder())()).i37();
      }
    }
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  if (Key_instance === VOID)
    new (Key())();
  return Key_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.h45_1 = LinkedHashMap().ec();
        this.i45_1 = null;
        this.j45_1 = null;
        this.k45_1 = null;
      }
      l45(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.h45_1.z4(customScalarAdapters.p45_1);
        return this;
      }
      a5() {
        this.h45_1.a5();
      }
      i37() {
        return new (CustomScalarAdapters())(this.h45_1, this.i45_1, this.j45_1, this.k45_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CustomScalarAdaptersClass;
function CustomScalarAdapters() {
  if (CustomScalarAdaptersClass === VOID) {
    class $ {
      constructor(customScalarAdapters, falseVariables, deferredFragmentIdentifiers, errors) {
        Key_getInstance();
        this.m45_1 = falseVariables;
        this.n45_1 = deferredFragmentIdentifiers;
        this.o45_1 = errors;
        this.p45_1 = customScalarAdapters;
      }
      q45(customScalar) {
        var registered = this.p45_1.u4(customScalar.k43_1);
        if (!(registered == null)) {
          return isInterface(registered, Adapter()) ? registered : THROW_CCE();
        }
        var tmp;
        switch (customScalar.j43_1) {
          case 'com.apollographql.apollo.api.Upload':
            tmp = get_UploadAdapter();
            break;
          case 'kotlin.String':
          case 'java.lang.String':
            tmp = get_StringAdapter();
            break;
          case 'kotlin.Boolean':
          case 'java.lang.Boolean':
            tmp = get_BooleanAdapter();
            break;
          case 'kotlin.Int':
          case 'java.lang.Int':
            tmp = get_IntAdapter();
            break;
          case 'kotlin.Double':
          case 'java.lang.Double':
            tmp = get_DoubleAdapter();
            break;
          case 'kotlin.Long':
          case 'java.lang.Long':
            tmp = get_LongAdapter();
            break;
          case 'kotlin.Float':
          case 'java.lang.Float':
            tmp = get_FloatAdapter();
            break;
          case 'kotlin.Any':
          case 'java.lang.Object':
            tmp = get_AnyAdapter();
            break;
          default:
            // Inline function 'kotlin.error' call

            var message = "Can't map GraphQL type: `" + customScalar.k43_1 + '` to: `' + customScalar.j43_1 + '`. Did you forget to add a scalar Adapter?';
            throw IllegalStateException().o(toString(message));
        }
        var tmp_0 = tmp;
        return isInterface(tmp_0, Adapter()) ? tmp_0 : THROW_CCE();
      }
      m3() {
        return Key_getInstance();
      }
      r45(falseVariables, deferredFragmentIdentifiers, errors) {
        if (falseVariables == null && deferredFragmentIdentifiers == null && errors == null && this.m45_1 == null && this.n45_1 == null && this.o45_1 == null) {
          return this;
        }
        return new (CustomScalarAdapters())(this.p45_1, falseVariables, deferredFragmentIdentifiers, errors);
      }
    }
    protoOf($).s45 = get;
    protoOf($).t45 = fold;
    protoOf($).u45 = minusKey;
    protoOf($).w41 = plus;
    initMetadataForClass($, 'CustomScalarAdapters', VOID, VOID, [Element()]);
    CustomScalarAdaptersClass = $;
  }
  return CustomScalarAdaptersClass;
}
//region block: exports
export {
  Builder as Builder4ra56zvvku0a,
  Key_getInstance as Key_getInstance1eahaybkym4fk,
};
//endregion

//# sourceMappingURL=CustomScalarAdapters.mjs.map
